<template>
  <div class="panel-body">
    <div v-html="replaceHTMLSellerInfo(description.content)"></div>
  </div>
</template>

<script>
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      description: {
        kind: null,
        title: null,
        content: null
      },
      loader: null
    }
  },
  created () {
    this.getDescriptions()
  },
  methods: {
    replaceHTMLSellerInfo,
    async getDescriptions () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.getDescriptions()
        .then((response) => {
          this.description = response.data
        })
        .catch((err) => {
          this.$events.fire('handleError', err)
        })
      this.loader && this.loader.hide()
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.top_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/Top.vue